var map = {
	"./SVG_Logo.svg.png": 5924,
	"./api.svg": 4266,
	"./apiORIG.svg": 8953,
	"./code.svg": 8165,
	"./css.svg": 7099,
	"./ejs.svg": 1822,
	"./express.svg": 7794,
	"./git.svg": 1046,
	"./github.svg": 6747,
	"./gmail.svg": 7456,
	"./html.svg": 4261,
	"./javascript-extra.svg": 5934,
	"./js.svg": 4691,
	"./left.svg": 6485,
	"./linkedin-white.svg": 8864,
	"./live-link.svg": 9913,
	"./mongodb.svg": 5860,
	"./ms-access.svg": 1057,
	"./ms-excel.svg": 1976,
	"./mysql.svg": 5632,
	"./node.svg": 1250,
	"./npm.svg": 5001,
	"./php.svg": 1634,
	"./postgre-sql.svg": 191,
	"./python.svg": 5164,
	"./react.svg": 9423,
	"./right.svg": 888,
	"./svg.svg": 8048
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8719;